import { parseJwt } from 'utils/parse';

const adapt = httpResponse => {
  if (httpResponse.data.authToken) {
    const { authToken } = httpResponse.data;
    const payload = parseJwt(authToken.token);
    const comps = JSON.parse(payload.comps);
    return {
      ...httpResponse,
      data: {
        user: {
          id: payload.nameid,
          name: payload.unique_name,
        },
        company: {
          id: comps[0]?.Id,
        },
        unit: {
          id: comps[0]?.Units[0],
          companyId: comps[0]?.Id,
        },
        //providerId: fornecedor,
        authToken: {
          token: authToken.token,
          refreshToken: authToken.refreshToken,
          expiresIn: authToken.expiresIn,
        },
      },
    };
  } else {
    return httpResponse;
  }
};

const loginAdapter = httpResponsePromise => {
  return httpResponsePromise.then(
    resolve => adapt(resolve),
    // `Login/index.js` (handleLogin) sempre esperou o formato de resposta do servidor aqui
    // (`.status`/`.data`) mesmo pra erro — senha errada (401) e rede bloqueada (403) chegam
    // como rejeição, não exceção, e `handleLogin` lê `response.status`/`response.data` dentro
    // do próprio `try`. Antes da mudança do Reauth em `handleAuthError.js` (que passou a
    // rejeitar com o `error` inteiro, não `error.response`, pra não quebrar o interceptor de
    // Sentry em erro de rede puro), esse `reject` já vinha como `error.response` — coincidência
    // que sempre sustentou esse contrato. Normaliza aqui: se houver resposta do servidor, usa
    // ela (mantém `Login/index.js` funcionando); erro de rede puro (sem `.response`) passa
    // como está e cai no catch genérico — que é o comportamento correto pra esse caso.
    reject => reject?.response ?? reject,
  );
};

export { loginAdapter };
